import FileUpload from '../components/FileUpload';

const HomePage: React.FC = () => {
  return (
    <div className="page-narrow">
      <div className="card card-body">
        <h1 className="page-title mb-1">JW 구역 관리</h1>
        <p className="text-sm text-gray-400 mb-6">
          Excel → DB → 방문 계획
        </p>
        <FileUpload />
      </div>
    </div>
  );
};

export default HomePage;
